<!-- input loading -->
<ng-container *ngIf="isBusy">
  <input type="text" placeholder="Type something..." class="form-control" [disabled]="true">
</ng-container>

<!-- 
<input type="text" placeholder="Type something..." class="form-control" [formControl]="formControl" [matAutocomplete]="auto">
<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)">
  <mat-option *ngIf="isPropertyLoading" class="is-loading">
    <mat-spinner diameter="20" style="float:left"></mat-spinner>
    <span style="display: block;margin-left: 30px;font-size: 15px;">Searching...</span>
  </mat-option>
  <ng-container *ngIf="!isPropertyLoading && summary">
    <mat-option *ngFor="let data of summary.Data" [value]="data">
      <div class="suggest-group">
        <div class="suggest-img">
          <!-- <img image src="../../assets/images/MANAGESUPPLIERGREY.png">
          <img [src]="getImageFilteredSummary(data[retrieveFilteredData('ID')]) ? getImageFilteredSummary(data[retrieveFilteredData('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
        </div>
        <div class="suggest-sub-group">
          <p class="suggest-header">{{data[retrieveFilteredData('prop1')]}}</p>
          <p class="suggest-sub-header">{{data[retrieveFilteredData('prop2')]}}</p>
          <p class="suggest-desc">{{data[retrieveFilteredData('prop4')]}}</p>
        </div>
      </div>
    </mat-option>
  </ng-container>
</mat-autocomplete> -->
<!-- <mat-form-field appearance="outline">
<input #textbox matInput type="text" *ngIf="propertySummary"
        [id]="propertySummary.PropertyName"
        [ngClass]="{'form-control': true, 'uppercase': propertySummary.PropertyDisplayFormat == 'UPPER'}" 
        [attr.name]="propertySummary.PropertyName"
        autocomplete="{{propertySummary.IsAutoComplete ? propertySummary.PropertyName : 'off'}}"
        [name] = "propertySummary.PropertyName"
        [(ngModel)]="propertySummary.PropertyValueDisplay" 
        [value]="propertySummary.PropertyValueDisplay" 
        (change)="onValueChange(textbox.value)">
      </mat-form-field> -->

<ng-container *ngIf="propertySummary">
  <ng-container *ngIf="propertySummary.PropertyIsEditable == true;else isDisplay">
    <div *ngIf="propertySummary.PropertyValidation; else noValidate" class="property-group">
      <mat-form-field appearance="outline" class="mat-form-field summary-suggestion-form">
        <mat-chip-list #chipList aria-label="Selected catalogue" [(ngModel)]="value" [name]="propertySummary.PropertyName" >
          <mat-chip
            *ngFor="let data of selectedData"
            [removable]="true"
            (removed)="remove(data)">
            {{data[retrieveFilteredData('prop1')]}}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>

          <input #textbox 
          #trigger="matAutocompleteTrigger"
          type="text" matInput
          placeholder="Type something..." 
          [ngClass]="{'form-control mat-form': true}" 
          [name]="propertySummary.PropertyName" 
          #PropertyValueDisplay="ngModel" 
          [(ngModel)]="propertySummary.PropertyValue" 
          (ngModelChange)="onValueChange(propertySummary.PropertyValue)"
          [matAutocomplete]="autoComplete"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [pattern]="propertySummary.PropertyValidation.PropertyFormat ? propertySummary.PropertyValidation.PropertyFormat : null" 
          [maxlength]="propertySummary.PropertyValidation.PropertyLength == 0 ? null : propertySummary.PropertyValidation.PropertyLength" 
          [required]="propertySummary.PropertyValidation.IsMandatory">

          <mat-autocomplete #autoComplete="matAutocomplete" (optionSelected)="onSelectionChanged($event)" [displayWith]="displayFn.bind(this)">
            <mat-option *ngIf="isPropertyLoading" class="is-loading" [disabled]="true">
              <mat-spinner diameter="20" style="float:left"></mat-spinner>
              <span style="display: block;margin-left: 30px;font-size: 15px;">Searching...</span>
            </mat-option>
            <ng-container *ngIf="!isPropertyLoading && summary">
              <mat-option *ngFor="let data of summary.Data" [value]="data">
                <!-- this should be taking the summary layout -->
                <div class="suggest-group">
                  <div class="suggest-img">
                    <!-- <img image src="../../assets/images/MANAGESUPPLIERGREY.png"> -->
                    <img [src]="getImageFilteredSummary(data[retrieveFilteredData('ID')]) ? getImageFilteredSummary(data[retrieveFilteredData('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
                  </div>
                  <div class="suggest-sub-group">
                    <p class="suggest-header">{{data[retrieveFilteredData('prop1')]}}</p>
                    <p class="suggest-sub-header">{{data[retrieveFilteredData('prop2')]}}</p>
                    <p class="suggest-desc">{{data[retrieveFilteredData('prop3')]}}</p>
                  </div>
                </div>
              </mat-option>
              <mat-option *ngIf="summary.Data.length != summary.TotalRows" [disabled]="isFetching" class="load-more-option">
                <div class="load-more-group" (click)="onLoadMore($event)">
                  <div class="load-more">
                    <mat-icon *ngIf="!isFetching">add_circle_outline</mat-icon>
                    <mat-spinner *ngIf="isFetching" diameter="20"></mat-spinner>
                    <span>{{isFetching ? 'Loading' : 'Show more items'}}</span>
                  </div>
                </div>
              </mat-option>
              <mat-option style="display: none;"></mat-option>
            </ng-container>
          </mat-autocomplete>
        </mat-chip-list>
        <mat-error>{{ propertySummary.PropertyDisplay }} is required</mat-error>
      </mat-form-field>
      <!-- <span></span>  <!-- required for validation purpose
      <div *ngIf="PropertyValueDisplay.invalid" class="invalid-feedback">
        <div *ngIf="PropertyValueDisplay.errors.required">{{ propertySummary.PropertyDisplay }} is required</div>
        <div *ngIf="PropertyValueDisplay.errors.maxlength">{{ propertySummary.PropertyDisplay }} cannot be more than {{ propertySummary.PropertyValidation.PropertyLength }}</div>
        <div *ngIf="PropertyValueDisplay.errors.pattern">{{ propertySummary.PropertyValidation.FormatValidationMessage }}</div>
      </div> -->
    </div>
    <ng-template #noValidate>
      <input #textbox type="text" placeholder="Type something..." class="form-control" [name]="propertySummary.PropertyName" #PropertyValueDisplay="ngModel" [(ngModel)]="propertySummary.PropertyValue" 
      (ngModelChange)="onValueChange(textbox.value)" [matAutocomplete]="autoComplete">
      <mat-autocomplete #autoComplete="matAutocomplete" [displayWith]="displayFn.bind(this)">
        <mat-option *ngIf="isPropertyLoading" class="is-loading">
          <mat-spinner diameter="20" style="float:left"></mat-spinner>
          <span style="display: block;margin-left: 30px;font-size: 15px;">Searching...</span>
        </mat-option>
        <ng-container *ngIf="!isPropertyLoading && summary">
          <mat-option *ngFor="let data of summary.Data" [value]="data">
            <div class="suggest-group">
              <div class="suggest-img">
                <!-- <img image src="../../assets/images/MANAGESUPPLIERGREY.png"> -->
                <img [src]="getImageFilteredSummary(data[retrieveFilteredData('ID')]) ? getImageFilteredSummary(data[retrieveFilteredData('ID')]) : '../../assets/images/no_image_available.jpeg'" alt="image">
              </div>
              <div class="suggest-sub-group">
                <p class="suggest-header">{{data[retrieveFilteredData('prop1')]}}</p>
                <p class="suggest-sub-header">{{data[retrieveFilteredData('prop2')]}}</p>
                <p class="suggest-desc">{{data[retrieveFilteredData('prop3')]}}</p>
              </div>
            </div>
          </mat-option>
        </ng-container>
      </mat-autocomplete>
    </ng-template>
  </ng-container>
  <ng-template>
    <span [innerHTML]="propertySummary.PropertyValueDisplay" class="display-prop" [id]="propertySummary.PropertyName"></span>
  </ng-template>
</ng-container>